<template>
<tr :class="[{'race' : true}, winner_party(race), {'pickup' : winner_is_pickup(race)}, {'winner' : has_winner(race)}]">
    <td class="name">
        <div>
            <a :href="race_detail_link(race, election_type.basename)" v-html="state_name_display(race.stateName, race.seatName, election_type.basename)+' ('+electoral_display(race.statePostal)+')'"></a>
        </div>
    </td>
  <td v-for="candidate in candidates_with_party(race.reportingUnit.candidates, 'Dem', 1)" class="candidate">
    <span v-if="election_type.basename != 'president'" v-html="candidate.last"></span> 
    <span v-html="vote_perc_display(candidate.voteCount, race.voteTotal)"></span>
  </td>
  <td v-if="candidates_with_party(race.reportingUnit.candidates, 'Dem', 1).length == 0"></td>
  <td v-for="candidate in candidates_with_party(race.reportingUnit.candidates, 'GOP', 1)" class="candidate">
    <span v-if="election_type.basename != 'president'" v-html="candidate.last"></span> 
    <span v-html="vote_perc_display(candidate.voteCount, race.voteTotal)"></span>
  </td>
  <td v-if="candidates_with_party(race.reportingUnit.candidates, 'GOP', 1).length == 0"></td>
  <td v-for="candidate in column_candidates(race.reportingUnit.candidates, 1)" class="candidate other_party">
    <span v-html="candidate.last"></span> 
    <span v-html="vote_perc_display(candidate.voteCount, race.voteTotal)"></span>
  </td>
  <td class="other_party" v-if="column_candidates(race.reportingUnit.candidates, 1).length == 0 && any_column_candidates(races[election_type.basename], 1)"></td>
  <td class="spacer"></td>
  <td class="percent_in"><div v-html="display_precincts_perc(race)"></div></td>
  <!--<td class="hold"><div v-html="winner_hold_pickup_text(race)"></div></td>-->
</tr>
</template>

<script>

import ElectionNightMixin from './ElectionNightMixin.js';

export default {
    name: 'rc-widget-pres-row',
    mixins: [
        ElectionNightMixin,
    ],
    props: ['races', 'race', 'election_type'],
}
</script>

<style lang="scss">

</style>